import React, { useState, useEffect } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import AdminLogin from "./AdminLogin";
import { fetchApi } from "../../apis/Index";

const AdminLayout = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    checkAdmin();
  }, []);

  const checkAdmin = async () => {
    try {
      const response = await fetchApi("https://wittynailtip.com/backend/admin-check.php");
      if (response.data && response.data.is_admin) {
        setIsAdmin(true);
      }
    } catch (error) {
      console.error("Failed to check admin status", error);
    } finally {
      setLoading(false);
    }
  };

  const navLinks = [
    { name: "Dashboard", path: "/admin", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
    { name: "Products", path: "/admin/products", icon: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" },
    { name: "Orders", path: "/admin/orders", icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" },
    { name: "Coupons", path: "/admin/coupons", icon: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" },
  ];

  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FFB7CF]"></div>
      </div>
    );
  }

  if (!isAdmin) {
    return <AdminLogin onLoginSuccess={() => setIsAdmin(true)} />;
  }

  return (
    <div className="w-full min-h-screen bg-gray-50 flex font-jost">
      {/* Admin Sidebar */}
      <div className="w-[280px] bg-white border-r border-gray-100 hidden lg:flex flex-col h-screen fixed left-0 top-0 overflow-y-auto">
        <div className="p-6 border-b border-gray-50">
          <Link to="/" className="flex items-center gap-2">
            <h1 className="text-2xl font-bold text-gray-900">Witty<span className="text-[#FFB7CF]">Admin</span></h1>
          </Link>
        </div>
        
        <div className="p-4 flex-1">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 px-3">Management</p>
          <nav className="space-y-2">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path || (link.path !== "/admin" && location.pathname.startsWith(link.path));
              return (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`flex items-center gap-3 px-3 py-3 rounded-xl transition-colors font-medium ${
                    isActive 
                      ? "bg-[#FFB7CF] text-white" 
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                  }`}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={link.icon}></path>
                  </svg>
                  {link.name}
                </Link>
              );
            })}
          </nav>
        </div>
        
        <div className="p-4 border-t border-gray-50">
          <Link to="/" className="flex items-center gap-3 px-3 py-3 text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-xl transition-colors font-medium">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
            Exit Admin
          </Link>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 lg:ml-[280px] p-4 lg:p-10 w-full pb-24 lg:pb-10">
        <Outlet />
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 flex justify-around items-center px-2 py-3 z-40 pb-safe shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        {navLinks.map((link) => {
          const isActive = location.pathname === link.path || (link.path !== "/admin" && location.pathname.startsWith(link.path));
          return (
            <Link
              key={link.name}
              to={link.path}
              className={`flex flex-col items-center gap-1 px-3 py-1 rounded-xl transition-colors font-medium text-[10px] sm:text-xs ${
                isActive 
                  ? "text-[#FFB7CF]" 
                  : "text-gray-400 hover:text-gray-900"
              }`}
            >
              <svg className={`w-5 h-5 sm:w-6 sm:h-6 ${isActive ? 'stroke-2' : 'stroke-1'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d={link.icon}></path>
              </svg>
              {link.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default AdminLayout;
